/* Cozyleigh prototype hearts. Shared by sections/cozyleigh-prototypes (/pages/from-the-studio) and
   sections/cozyleigh-workbench (the homepage teaser), so a heart tapped on one shows on the other.
   Each wrapper [data-clp] carries its Klaviyo public site ID (data-site), messages (data-ok, data-err) and where the
   signup came from (data-source, saved as the Klaviyo custom source). Each .clp-card carries data-proto (handle),
   data-list (the prototype's Klaviyo list) and data-name. The heart is remembered in this browser
   (localStorage "cl_proto_<handle>" = hearted / joined / off); the email form only renders when the card has a list.
   Each heart is also counted by the shop as "prototype--<handle>" (window.clHearts from assets/cozyleigh-saved.js). */
(function () {
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  function wire(card) {
    if (card.dataset.clpReady) return;
    card.dataset.clpReady = '1';
    var box = card.closest('[data-clp]') || document.body;
    var SITE = box.dataset.site || '', OK = box.dataset.ok || '', ERR = box.dataset.err || '';
    var SOURCE = box.dataset.source || 'From the studio';
    var handle = card.dataset.proto, btn = card.querySelector('.clp-heart__btn'), lab = card.querySelector('.clp-heart__label');
    if (!btn || !lab) return;
    var form = card.querySelector('.clp-form'), key = 'cl_proto_' + handle;
    function setOn(on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      lab.textContent = on ? lab.dataset.on : lab.dataset.off;
    }
    if (store(key) === 'joined' || store(key) === 'hearted') setOn(true);
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-pressed') !== 'true';
      setOn(on);
      if (on) { if (store(key) !== 'joined') store(key, 'hearted'); if (form && store(key) !== 'joined') { form.hidden = false; form.querySelector('input').focus(); } }
      else { store(key, 'off'); if (form) form.hidden = true; }
      // Counted by the shop (assets/cozyleigh-saved.js), no email needed; "N people love this" shows from 5.
      if (window.clHearts) {
        window.clHearts.send(on ? ['prototype--' + handle] : [], on ? [] : ['prototype--' + handle]);
        window.clHearts.celebrate(btn, on);
      }
      if (window.clAnalytics) window.clAnalytics.componentInteraction('prototype', on ? 'like' : 'unlike');
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) { try { Shopify.analytics.publish('cozyleigh_prototype_heart', { prototype: handle, on: on }); } catch (e) {} }
    });
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input'), msg = form.querySelector('.clp-form__msg'), email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = ERR; input.focus(); return; }
      var submit = form.querySelector('button'); submit.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(SITE), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: SOURCE + ': ' + card.dataset.name,
          profile: { data: { type: 'profile', attributes: { email: email, properties: { prototype_interest: card.dataset.name } } } }
        }, relationships: { list: { data: { type: 'list', id: card.dataset.list } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        store(key, 'joined'); msg.textContent = OK; input.value = ''; input.disabled = true;
      }).catch(function () { msg.textContent = ERR; submit.disabled = false; });
    });
  }

  function init() { document.querySelectorAll('.clp-card').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // sections added or re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
